import React, { useContext } from 'react';
import { CsvContext } from '../provider/CSVProvider';
import { segmentValueCalculator, indexValueCalculator } from "../utils/calcUtils";
import Decimal from 'decimal.js';

const SubmitButton = ({ filters, principalAmountMinimum, annualRateMinimum, onSubmit }) => {

    const { optionsData } = useContext(CsvContext);

    const isFormValid = filters.yearsInvested !== "" && filters.principalAmount !== "" && filters.principalAmount >= principalAmountMinimum 
      && filters.annualRate !== "" && filters.annualRate >= annualRateMinimum;
  
    const handleSubmit = () => {
      const options = optionsData.filter(option => ((filters.index === "" || option.Index === filters.index)
        && option.Years === filters.yearsInvested && new Decimal(filters.principalAmount.toString()).greaterThanOrEqualTo(new Decimal(option.Minimum.replace(',','')))));
      const principalAmount = new Decimal(filters.principalAmount.toString());
      const annualRate = new Decimal(filters.annualRate.toString());
      const ratesArray = [annualRate.neg(), annualRate.div(-2), new Decimal(0), annualRate.div(2), annualRate, annualRate.mul(2)].sort((a,b) => a.comparedTo(b));
      const inputRateIndex = ratesArray.findIndex(rate => rate.equals(annualRate));
      let bestOptions = [];
      let indexValues = [];

      options.forEach(option => {
        let rateValues = [];

        ratesArray.forEach(rate => {
          const values = segmentValueCalculator(principalAmount, rate, option);
          const finalAmount = values[values.length - 1].amount;
          const finalRate = values[values.length - 1].rate;
          const finalMonth = values[values.length - 1].month;
          const finalYear = values[values.length - 1].year;

          if (rate.equals(annualRate)) {
            console.log(`
              Provider:        ${option.Provider}
              SegmentType:     ${option.SegmentType}
              SegmentMapping:  ${option.SegmentMapping}
              Index:           ${option.Index}
              Minimum:         ${option.Minimum}
              Buffer:          ${option.Buffer}
              Floor:           ${option.Floor}
              DownPart:        ${option.DownsideParticipation}
              Dual:            ${option.Dual}
              Cap:             ${option.Cap}
              Step:            ${option.Step}
              Yield:           ${option.Yield}
              YieldInterest:   ${option.YieldInterest}
              Participation:   ${option.Participation}
              Participation2:  ${option.Participation2}
              Tier:            ${option.Tier}
              Milestone:       ${option.Milestone}
              Boost:           ${option.Boost}
              Spread:          ${option.Spread}
              Protection:      ${option.Protection}
              AnnualFeeRate:   ${option.AnnualFeeRate}
              Segment IRR:     ${finalRate.toString()}
              Final Amount:    ${finalAmount.toString()}
              `);
          }

          rateValues.push({
            rate: rate,
            values: values,
            finalAmount: finalAmount,
            finalRate: finalRate,
            finalMonth: finalMonth,
            finalYear: finalYear
          });
        });

        bestOptions.push({
          option: option,
          rateValues: rateValues
        });
      })

      bestOptions = bestOptions.sort((a,b) => b.rateValues[inputRateIndex].finalAmount.comparedTo(a.rateValues[inputRateIndex].finalAmount));

      ratesArray.forEach(rate => {
        const values = indexValueCalculator(principalAmount, rate, filters.yearsInvested);
        const finalAmount = values[values.length - 1].amount;
        const finalRate = values[values.length - 1].rate;
        indexValues.push({
          values: values,
          finalAmount: finalAmount,
          finalRate: finalRate
        });
      });

      onSubmit(bestOptions.slice(0,5),indexValues,inputRateIndex);
    };

    return (
        <button 
            onClick={handleSubmit} 
            style={{ width: "100%", marginTop: "10px" }}
            className={`btn waves-effect waves-light blue ${!isFormValid ? "disabled" : ""}`}
            disabled={!isFormValid}>
            Calculate
        </button>
    )
};

export default SubmitButton;